/* SET STATE */
export const SET_STATE_UNITMEASURE = "SET_STATE_UNITMEASURE"

/* LAB AREAS */
export const GET_UNITMEASURES = "GET_UNITMEASURES"
export const GET_UNITMEASURES_SUCCESS = "GET_UNITMEASURES_SUCCESS"
export const GET_UNITMEASURES_FAIL = "GET_UNITMEASURES_FAIL"

/* LAB AREA */
export const GET_UNITMEASURE = "GET_UNITMEASURE"
export const GET_UNITMEASURE_SUCCESS = "GET_UNITMEASURE_SUCCESS"
export const GET_UNITMEASURE_FAIL = "GET_UNITMEASURE_FAIL"

/**
 * ADD LAB AREA
 */
 export const ADD_NEW_UNITMEASURE = "ADD_NEW_UNITMEASURE"
 export const ADD_UNITMEASURE_SUCCESS = "ADD_UNITMEASURE_SUCCESS"
 export const ADD_UNITMEASURE_FAIL = "ADD_UNITMEASURE_FAIL"

 /**
 * UPDATE LAB AREA
 */
export const UPDATE_UNITMEASURE = "UPDATE_UNITMEASURE"
export const UPDATE_UNITMEASURE_STATUS = "UPDATE_UNITMEASURE_STATUS"
export const UPDATE_UNITMEASURE_SUCCESS = "UPDATE_UNITMEASURE_SUCCESS"
export const UPDATE_UNITMEASURE_FAIL = "UPDATE_UNITMEASURE_FAIL"

/**
 * DELETE LAB AREA
 */
export const DELETE_UNITMEASURE = "DELETE_UNITMEASURE"
export const DELETE_UNITMEASURE_SUCCESS = "DELETE_UNITMEASURE_SUCCESS"
export const DELETE_UNITMEASURE_FAIL = "DELETE_UNITMEASURE_FAIL"
